import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const show = defineMessage({
  type: 'papercuts-show'
});
const hide = defineMessage({
  type: 'papercuts-hide'
});
const reposition = defineMessage({
  type: 'papercuts-reposition',
  payloadSchema: t.object({
    bottomOffset: t.optional(t.number),
    rightOffset: t.optional(t.number)
  })
});
const pickingStart = defineMessage({
  type: 'papercuts-picking-start'
});
const pickingEnd = defineMessage({
  type: 'papercuts-picking-end'
});
export const papercutsControls = {
  show,
  hide,
  reposition,
  pickingStart,
  pickingEnd
};